/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .kt-header__topbar>:last-child:not([role=tooltip]) .kt-header__topbar-item{margin-right:0!important}[_nghost-%COMP%]     .kt-header__topbar .kt-header__topbar-item{margin-right:.36rem!important}"];
export { styles as styles };
